const SYSTEM_USER_LABELS = Object.freeze({
  'system-auto-start': 'work.order.history.userStart',
  'system-auto-end': 'work.order.history.userEnd',
} as const);

export function getUserLabelKey(userId: string): string | null {
  return SYSTEM_USER_LABELS[userId as keyof typeof SYSTEM_USER_LABELS] || null;
}
